module.exports = __webpack_public_path__ + "static/media/secure.6ecd8762.svg";